import script from "./webPc.vue?vue&type=script&setup=true&lang=js"
export * from "./webPc.vue?vue&type=script&setup=true&lang=js"

import "./webPc.vue?vue&type=style&index=0&id=ed999066&lang=scss"

const __exports__ = script;

export default __exports__